export const recurringValuePodcastLogoUrl = 'https://images.recurringvaluepodcast.com/Recurring%20Value%20podcastupdated.png';

// Favicon from R2 bucket custom domain
export const recurringValueFaviconUrl = 'https://images.recurringvaluepodcast.com/The%20recurring%20Value%20podcast%20icon.ico'; 